import { Alert, AlertTitle, Typography } from '@cmg/design-system';
import { useFormikContext } from 'formik';
import isEmpty from 'lodash/isEmpty';
import { useMemo } from 'react';

import { USER_DETAIL_FIELD_LABELS } from '../models/UserDetailsSection.model';

function isUserDetailFieldLabelKey(field: string): field is keyof typeof USER_DETAIL_FIELD_LABELS {
  return field in USER_DETAIL_FIELD_LABELS;
}

export function EmployeeValidationAlert() {
  const { errors } = useFormikContext();

  const errorFieldLabels = useMemo(() => {
    const errorFields = Object.keys(errors);
    return errorFields
      .filter(isUserDetailFieldLabelKey)
      .map(field => USER_DETAIL_FIELD_LABELS[field]);
  }, [errors]);

  if (isEmpty(errorFieldLabels)) {
    return null;
  }

  return (
    <Alert severity="error">
      <AlertTitle>An entry is required or has invalid value:</AlertTitle>
      <Typography variant="body2">{errorFieldLabels.join(', ')}</Typography>
    </Alert>
  );
}
